/* UniCurt preview 188133015737 only. Version: uc-photo-cart-display-v1-20261030.
 * Presentation only: no fetch, price overrides, cart writes, checkout, or orders.
 * Preserve Shopify-rendered titles, currency, prices, quantity values and removal controls.
 */
(() => {
  'use strict';
  if (String(window.Shopify?.theme?.id) !== '188133015737' || window.__ucPhotoCartDisplay) return;
  window.__ucPhotoCartDisplay = 'uc-photo-cart-display-v1-20261030';
  const VARIANT = '68089385025721';
  const watched = new WeakSet();
  const camera = '<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true" focusable="false"><path d="M8 5.5 9.5 3h5L16 5.5h3.5A1.5 1.5 0 0 1 21 7v12a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19V7a1.5 1.5 0 0 1 1.5-1.5H8Z"/><circle cx="12" cy="12.5" r="4"/></svg><span>Photo approval</span>';

  function enhanceService(row) {
    const input = row.querySelector('input[data-quantity-variant-id="' + VARIANT + '"]');
    if (!input) return; // Never alter curtain or swatch rows.
    row.classList.add('uc-photo-cart-item');
    const media = row.querySelector('.cart-item__media');
    if (media && !media.querySelector('img, picture, [data-uc-photo-thumbnail]')) {
      const thumbnail = document.createElement('div');
      thumbnail.className = 'uc-photo-cart-thumbnail';
      thumbnail.dataset.ucPhotoThumbnail = '';
      thumbnail.setAttribute('role', 'img');
      thumbnail.setAttribute('aria-label', 'Pre-shipment photo approval service');
      thumbnail.innerHTML = camera;
      media.append(thumbnail);
    }
    const details = row.querySelector('.cart-item__details');
    if (details) {
      let note = details.querySelector('[data-uc-photo-once]');
      if (!note) {
        note = document.createElement('p');
        note.className = 'uc-photo-cart-note';
        note.dataset.ucPhotoOnce = '';
        const name = details.querySelector('.cart-item__name');
        if (name) name.insertAdjacentElement('afterend', note);
        else details.append(note);
      }
      // Do not disguise an unexpected existing quantity or silently change the cart.
      const text = Number(input.value) > 1
        ? 'Only one service is needed. Remove this line and add it once.'
        : 'One service per order.';
      if (note.textContent !== text) note.textContent = text;
    }
    input.readOnly = true;
    input.max = '1';
    input.setAttribute('aria-readonly', 'true');
    input.setAttribute('title', 'One photo approval service per order. Use Remove to cancel.');
    const quantity = input.closest('quantity-input');
    quantity?.querySelectorAll('button[name="plus"], button[name="minus"]').forEach(button => {
      button.disabled = true;
    });
  }

  function reconcile(root) {
    if (root.matches('cart-drawer')) {
      const contents = root.querySelector('#CartDrawer-CartItems');
      // The theme replaces #CartDrawer's children, not the outer custom element.
      // Only authoritative, server-rendered rows justify clearing the stale empty state.
      if (contents?.querySelector('.cart-item')) root.classList.remove('is-empty');
      else if (root.querySelector('.drawer__inner-empty')) root.classList.add('is-empty');
    }
    root.querySelectorAll('.cart-item').forEach(enhanceService);
  }

  function observe(root) {
    if (watched.has(root)) return;
    watched.add(root);
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (root.isConnected) reconcile(root);
      });
    });
    observer.observe(root, { childList: true, subtree: true });
    reconcile(root);
  }
  const init = () => document.querySelectorAll('cart-drawer, #main-cart-items').forEach(observe);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
